import {Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation} from '@angular/core';
import {SystemService} from '../../services/system.service';
import {EstimationRole, ProjectGroup} from '../../pages/product/product.model';
import Table = WebAssembly.Table;
import {MatTable} from '@angular/material/table';
import {MatSelect} from '@angular/material/select';
import {MatInput} from '@angular/material/input';

@Component({
    selector: 'estimation-list',
    templateUrl: './estimation-list.component.html',
    styleUrls: ['./estimation-list.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class EstimationListComponent implements OnInit {
    displayedColumns: string[] = ['roleName', 'estimatedHH', 'estimatedCosts'];
    dataSource: any[];

    @Input()
    entity: ProjectGroup;

    @Input()
    canModify: boolean;

    @Output('add')
    add: EventEmitter<any> = new EventEmitter();

    selectedRoleId: any;

    @ViewChild('roles')
    roleSelect: MatSelect;

    cantidad: string;

    constructor(public _systemService: SystemService) { }

    ngOnInit(): void {
        if (this.entity && this.entity.estimations) {
            this.dataSource = this.entity.estimations.sort(
                (a, b) => this.roleName(a.roleId).localeCompare(this.roleName(b.roleId))
            );
            // this.table.renderRows();
        }
    }

    agregarEstimacion(rol: any): void {

        // this.entity.estimationChanged = true;

        if (this.cantidad && !isNaN(Number(this.cantidad))){
            this.quitarEstimacion(rol.id);
            this.selectedRoleId = null;
            const newEst: EstimationRole = new EstimationRole();
            // const newEst: any = {};
            const cant: number = parseInt(this.cantidad, 10);
            newEst.estimatedHH = cant;
            newEst.hourIncome = rol.hourIncome;
            newEst.roleId = rol.id;
            newEst.id = 0;
            this.entity.estimations.push(newEst);
            this.entity.estimations = this.entity.estimations.slice();
            this.dataSource = this.entity.estimations;
            this.entity.estimationChanged = true;
            this.cantidad = null;
            this.roleSelect.value = null;
            // this.add.emit(newEst);
            // this.ngOnInit();
        }
    }

    selectEntity(entity: ProjectGroup): void{
        this.entity = entity;
        this.ngOnInit();
    }

    quitarEstimacion(roleId: number): number{
        const index: number = this.dataSource.findIndex( a => a.roleId === roleId);
        if (index >= 0 ) {
            this.dataSource.splice(index, 1);
            this.entity.estimationChanged = true;
            this.dataSource = [].concat(this.dataSource);
            this.cantidad = null;
            this.roleSelect.value = null;
            this.selectedRoleId = null;
        }

        return index;
    }

    roleName(roleId: number): string {
        // console.log(this._systemService.getRole(roleId));
        return this._systemService.getRole(roleId) ? this._systemService.getRole(roleId).name : '';
    }

    highlight(row): void {
        this.selectedRoleId = row.roleId;
    }
}
